/* PRODUCTS */
export const EDIT_ORDER = "EDIT_ORDER"
export const EDIT_ORDER_SUCCESS = "EDIT_ORDER_SUCCESS"
export const EDIT_ORDER_FAIL = "EDIT_ORDER_FAIL"